angular.module('rightPaneModule')
  .controller('GradeTeachersController', ['$scope', '$state', 'teacherApi', 'timeframe', 'tableSort', 'tableColumns', 'authentication', 'reportErrors', function ($scope, $state, $teacherApi, $timeframe, $tableSort, $tableColumns, dblAuthentication, $reportErrors) {

      var updateMode = function() {
          $scope.listTableColumns = $tableColumns.getColumns('teacher_fractions');

          $scope.activeMetric = $state.params.sort || $scope.listTableColumns[0];
      };

      updateMode();

      $scope.defaultMetric = 'percent_growth';

      $scope.years = {list: null, selected: {}};

      $scope.timeframes = {
          list: [
              {id: '7d', name: 'Last 7 Days', by: 'day', active: false},
              {id: '30d', name: 'Last 30 Days', by: 'week', active: true}
          ],
          selected: {}
      };

      var updateTeachers = function () {
          $scope.tableError = null;
          $scope.listTableData = undefined;
          $teacherApi.getTeachersReporting().then(function (data) {
              $scope.listTableData = $tableSort.sortColumn($scope.listTableColumns, data);
          }, function(error) {
              $scope.tableError = $reportErrors.getErrorMessage(error);
          });
      };

      var updateTableSort = function () {
          if ($scope.listTableData) {
              $scope.listTableData = $tableSort.sortColumn($scope.listTableColumns, $scope.listTableData);
          }
      };

      var updateFrequencyData = function () {
          $scope.frequencyError = null;
          $scope.frequencyData = undefined;
          $teacherApi.getTeachersFrequency().then(function (data) {
              $scope.frequencyData = data;
          }, function(error) {
              $scope.frequencyError = $reportErrors.getErrorMessage(error);
          });
      };

      var updateTeachersPaging = function (e, page) {
          $state.current.data.page = page;
          $scope.tableError = null;
          $scope.listTableData = undefined;
          $teacherApi.getTeachersReporting().then(function (data) {
              if (!$scope.listTableData) {
                  $scope.listTableData = [];
              }
              var uniqueList = _.uniq($scope.listTableData.concat(data), false, function (li) {
                  return li.id;
              });
              $scope.listTableData = uniqueList;
          }, function(error) {
              $scope.tableError = $reportErrors.getErrorMessage(error);
          });
      };

      var updateData = function () {
          updateMode();

          if (!$state.params.timeframe) {
              $timeframe.updateStateParams($scope.timeframes.selected.id, $scope.timeframes.selected.by)
                .then(function () {
                    updateTeachers();
                    updateFrequencyData();
                });
          } else {
              updateTeachers();
              updateFrequencyData();
          }
      };

      var initializeData = function (e, item) {
          $scope.item = item;
          updateData();

          $scope.$on('updateSortableTable', updateTableSort);

          $scope.$on('listTableRowClicked', function (e, item) {
              $scope.$emit('route', item);
          });

          $scope.$on('yearSelected', updateData);

          $scope.$on('timeframeSelected', updateData);

          $scope.$on('listTableNextPage', updateTeachersPaging);

          $scope.$on('updateYears', function (e, years) {
              $scope.years.list = angular.copy(years);
          });
      };

      $scope.$on('itemReady', initializeData);

  }]);
